/*
 * File: KeyDeals.tsx
 * Project: a-a
 * File Created: Monday, 6th January 2025 7:51:17 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 31st July 2025 10:55:23 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import InfiniteScrollColumn from '../../InfiniteScrollColumn/InfiniteScrollColumn';
import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import TodaysMeetingCard from './TodaysMeetingCard/TodaysMeetingCard';
import KeyDealsCard from './KeyDealsCard/KeyDealsCard';
import { Link, useParams } from 'react-router-dom';
import { ClientService } from '../../../../service/client.service';
import CustomButton from '../../CustomButton/CustomButton';
import styles from './KeyDeals.module.css';
type DealType = {
  accountId: string;
  name: string;
  accountName: string;
  stageName: string;
  amount: string | null;
  clientRevenue: string | null;
  companyRevenue: string | null;
  commitments: string | null;
  closeDate: string | null;
  lastModifiedByName: string | null;
  lastModifiedDate: string | null;
  createdByName: string | null;
  createdDate: string | null;
  ownerName: string | null;
  probability: number | null;
  type: string | null;
  iqScore: number | null;
  dealId: string | null;
};
const KeyDeals = ({
  setValue,
}: {
  setValue?: React.Dispatch<React.SetStateAction<number>> | undefined;
}) => {
  const screenHeight = window.innerHeight;
  const params = useParams();

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = React.useState<DealType[]>([
    {
      accountId: '',
      name: '',
      accountName: '',
      stageName: '',
      amount: null,
      clientRevenue: null,
      companyRevenue: null,
      commitments: null,
      closeDate: null,
      lastModifiedByName: null,
      lastModifiedDate: null,
      createdByName: null,
      createdDate: null,
      ownerName: null,
      probability: null,
      type: null,
      iqScore: null,
      dealId: null,
    },
  ]);

  const getKeyDeals = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res = await ClientService.getClientKeyDeals(id, {});
        const deals = res?.key_deals;
        console.log(res);
        if (deals) {
          setDetails(deals);
        } else {
          setDetails([]);
        }
      }
    } catch (err: any) {
      console.log(err, 'errdeal');
      // setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };
  console.log(details);
  useEffect(() => {
    getKeyDeals(params?.id || '');
  }, []);
  const Header = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant='responsiveHeading3'>Deals</Typography>
        <Link
          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/page/home`}
          style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
          target='_blank'
          rel='noopener noreferrer'
        >
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: { xs: '8px 8px 8px 14px', xl: '10px 10px 10px 16px' },
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='responsiveBody3'>Salesforce</Typography>
            <img src='/assets/link-2.svg' className={styles.captiv8Link} />
          </CustomCard>
        </Link>
      </Box>
    );
  };

  const Column = () => {
    return (
      // <Box
      //   sx={{
      //     display: 'flex',
      //     flexDirection: 'column',
      //     justifyContent: 'center',
      //     alignItems: 'center',
      //     flex: 1,
      //   }}
      // >
      loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            // justifyContent: 'center',
            // alignItems: 'center',
            // flex: 1,
            height: '100vh',
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '24vh'
            //   : screenHeight > 1000
            //   ? '20vh'
            //   : screenHeight > 900
            //   ? '17vh'
            //   : screenHeight > 800
            //   ? '10vh'
            //   : '2vh',
          }}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((val: any, ind: number) => (
            <KeyDealsCard key={val} data={details[0]} loading={true} />
          ))}
        </Box>
      ) : !details.length ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 600px)', // Fixed the missing space in calculation
            width: '100%', // Ensure the box takes full width
            gap: { xs: '10px', xl: '16px' }, // Add consistent spacing between elements
            textAlign: 'center', // Ensure all text is centered
            // paddingTop: '20px', // Add some padding from the top
            // paddingBottom: '20px',
            // flex: 1,
            // height:
            //   screenHeight > 1200
            //     ? '28vh'
            //     : screenHeight > 1100
            //     ? '24vh'
            //     : screenHeight > 1000
            //     ? '20vh'
            //     : screenHeight > 900
            //     ? '17vh'
            //     : screenHeight > 800
            //     ? '10vh'
            //     : '2vh',
          }}
        >
          {' '}
          <img src={'/assets/no-keydeals.svg'} className={styles['no-deals']} />
          <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
            No Deals Available
          </Typography>
          <Typography
            variant='responsiveBody3'
            color={zeplinColor.Neutral8}
            sx={{ textAlign: 'center' }}
          >
            Create new deals to keep track of client opportunities and activities.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            position: 'relative',
            height: 'calc(100vh - 620px)',
            // height: '100vh',
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '24vh'
            //   : screenHeight > 1000
            //   ? '20vh'
            //   : screenHeight > 900
            //   ? '17vh'
            //   : screenHeight > 800
            //   ? '10vh'
            //   : '2vh',
            // gap: { xs: '6px', xl: '12px' },
            gap: { xs: '10px', xl: '16px' },
            alignItems: 'center',
            // paddingBottom: '27rem',
          }}
        >
          {/* <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flex: 1,
              width: '100%',
              gap: { xs: '10px', xl: '16px' },
              overflowY: 'auto',
              height: 'calc(100vh - 510px)', // Adjusted height to fit within the viewport
              // paddingBottom: '27rem',
              // maxHeight: 'calc(100vh-300px)',
            }}
          > */}
          {details?.map(
            (val, index) =>
              index <= 9 && (
                <KeyDealsCard key={val?.accountId} data={val} index={index} setValue={setValue} />
              ),
          )}
          {details?.length ? (
            <CustomButton
              disabled={false}
              onClick={() => {
                setValue && setValue(3);
                sessionStorage.setItem('currentTab', '3');
              }}
              variant='outlined'
              color='secondary'
              style={{
                width: '75.29px',
                borderRadius: 50,
                height: 32,
                textAlign: 'center',
                gap: '16px',
              }}
              textStyle={{ color: zeplinColor.BasicBlack }}
              text={'See All'}
              icon={''}
              buttonVariant='buttonSmall'
            />
          ) : (
            ''
          )}
          {/* </Box> */}
        </Box>
      )
      // </Box>
    );
  };
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        // flex: 1,
        // height: screenHeight > 640 ? '25vh' : screenHeight > 500 ? '12vh' : '10vh',
        gap: '20px',
        // paddingTop: '10px',
        overflowY: 'hidden',
      }}
    >
      <Header />
      <Column />
      {/* <InfiniteScrollColumn header={<Header />} content={<Column />} height='30vh' /> */}
    </Box>
  );
};

export default KeyDeals;
